/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultUiNotificationResponse } from '../../models/api-response-paged-result-ui-notification-response';
import { PagedRequestUiNotificationRequest } from '../../models/paged-request-ui-notification-request';

export interface SearchNotificationState$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestUiNotificationRequest
}

export function searchNotificationState(http: HttpClient, rootUrl: string, params: SearchNotificationState$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultUiNotificationResponse>> {
  const rb = new RequestBuilder(rootUrl, searchNotificationState.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultUiNotificationResponse>;
    })
  );
}

searchNotificationState.PATH = '/v1/api/ui/notification/search';
